module.exports = __webpack_public_path__ + "img/forestry-bg.4ceab48e.png";